module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNjYuOSAyNjYuOSI+PHBhdGggZmlsbD0iIzI0ODNDNSIgZD0iTTI1Mi4yIDBIMTQuN0M2LjYgMCAwIDYuNiAwIDE0Ljd2MjM3LjRjMCA4LjEgNi42IDE0LjcgMTQuNyAxNC43aDEyNy44VjE2My41aC0zNC44di00MC4zaDM0LjhWOTMuNmMwLTM0LjUgMjEuMS01My4yIDUxLjgtNTMuMiAxNC43IDAgMjcuNCAxLjEgMzEuMSAxLjZ2MzZoLTIxLjNjLTE2LjcgMC0yMCA3LjktMjAgMTkuNnYyNS43SDIyNGwtNS4yIDQwLjNoLTM0LjdWMjY3aDY4YzguMSAwIDE0LjctNi42IDE0LjctMTQuN1YxNC43Yy4xLTguMS02LjUtMTQuNy0xNC42LTE0Ljd6Ii8+PC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./client/assets/img/logos/fb.svg
// module id = 340
// module chunks = 0